module.exports = __webpack_public_path__ + "img/gbsinbo_03.0a7ea314.png";